//import React, { useContext, useState, useEffect } from "react";

import { Capacitor } from "@capacitor/core";
import { Dlog } from "./../../../../../utils/Dlog";
import { Translate, Localize, translate, setLocale } from "react-i18nify";
import { getTelephoneErrorTranslateID } from "./../../../HelperFunctions/ErrorDisplayFunctions";

//import KioskContext from "../../../../../contexts/Kiosk/KioskContext";

/**
 *
 * @param {*} getSocketFunc This is a socket returned from getSocket() from SocketIOContext
 * @param {*} kioskkey Kiosk Key to login as
 */
export async function socketEventsHandler(
  socketEvents,
  sessionID,
  setAllFunc,
  setErrorMessageFunc,
  setShowconfirmdialogFunc,
  clearSocketEventsFunc
) {
  clearSocketEventsFunc(); //So that SocketEvents only trigger once
  Dlog("I think an event happened! (socketEventsHandler)", socketEvents);
  if (socketEvents == null) {
    console.log("(socketEventsHandler) socketEvents is null, ignoring");
    return;
  }

  let socketdata = socketEvents.data;
  Dlog("socketdata", socketdata);

  let action = socketdata.action;

  switch (action) {
    case "REQUESTCUSTOMERINFO_RESULT":
      //console.log("Got customer Info", socketdata.data);

      if (socketdata.result == "SUCCESS") {
        var customerFirstName = socketdata.data.firstName;
        var customerLastName = socketdata.data.lastName;
        var customerID = socketdata.data.uniqueID;

        setAllFunc(
          //customerName, //customerName
          customerFirstName, //customerFirstName
          customerLastName, //customerLastName
          customerID, //customerID
          null, //charityName
          null, //charityID
          null, //numBags
          null, //numLabels
          null, //labelsList
          sessionID //sessionID
        );

        Dlog(
          "[socketEventHelper] REQUESTCUSTOMERINFO_RESULT Got this data",
          socketdata.data.firstName,
          socketdata.data.lastName,
          socketdata.data.uniqueID,
          socketdata.data.languagePreference
        );

        if (socketdata.data.languagePreference) {
          console.log("Got Language Preferences, updating language:");
          if (socketdata.data.languagePreference == "fr") {
            setLocale("fr");
          }

          if (socketdata.data.languagePreference == "en") {
            setLocale("en");
          }
        }

        await setErrorMessageFunc("");
        setShowconfirmdialogFunc(true);
      } else if (socketdata.result == "ERROR") {
        var errorMessage = translate(
          getTelephoneErrorTranslateID(socketdata.errorcode)
        );

        await setErrorMessageFunc(errorMessage);
      }
      break;
  }
}

export async function submissionSocketEventsHandler({
  socketEvents,
  customerFirstName,
  customerLastName,
  customerID,
  charityName,
  charityID,
  numBags,
  numLabels,
  sessionID,
  setAllFunc,
  setLoadingFunc,
  setErrorCodeFunc,
  successFunc,
  errorFunc,
  clearSocketEventsFunc
}) {
  clearSocketEventsFunc(); //So that SocketEvents only trigger once
  Dlog("I think an event happened! (socketEventsHandler)", socketEvents);

  if (socketEvents == null) {
    Dlog("(socketEventsHandler) socketEvents is null, ignoring");
    return;
  }

  let socketdata = socketEvents.data;
  Dlog("socketdata", socketdata);

  let result = socketdata.result;
  let action = socketdata.action;

  switch (action) {
    case "KIOSKSUBMISSION_RESULT":
      //console.log("Got customer Info", socketdata.data);

      if (socketdata.result == "SUCCESS") {
        Dlog("[DEBUG] CHECKING socketdata", socketdata);

        // console.log(
        //   "[DEBUG] socketEventHelper.js customerFirstName",
        //   customerFirstName
        // );
        // console.log(
        //   "[DEBUG] socketEventHelper.js customerLastName",
        //   customerLastName
        // );
        // console.log(
        //   "[DEBUG] [Issue01] socketEventHelper.js customerID",
        //   customerID
        // );
        // console.log(
        //   "[DEBUG] [Issue01] socketEventHelper.js charityName",
        //   charityName
        // );
        // console.log(
        //   "[DEBUG] [Issue01] socketEventHelper.js charityID",
        //   charityID
        // );
        // console.log("[DEBUG] [Issue01] socketEventHelper.js numBags", numBags);
        // console.log(
        //   "[DEBUG] [Issue01] socketEventHelper.js numLabels",
        //   numLabels
        // );

        var bagtagList = socketdata.data.bagtagList;

        setAllFunc(
          //customerName, //customerName
          customerFirstName, //customerFirstName
          customerLastName, //customerLastName
          customerID, //customerID
          charityName, //charityName
          charityID, //charityID
          socketdata.data.numBags, //numBags
          socketdata.data.numLabels, //numLabels
          bagtagList, //labelsList
          sessionID //sessionID
        );

        setLoadingFunc(false);
        successFunc();
        return;
      } else if (socketdata.result == "ERROR") {
        setLoadingFunc(false);
        switch (socketdata.errorcode) {
          case 400:
            if (socketdata.data.errorCode == "E1") {
              return setErrorCodeFunc(socketdata.data.errorCode);
            } else {
              return errorFunc(); //typically navigate("/errorscreen");
            }
          case 429:
            return setErrorCodeFunc(429);
          //case Invalid override code
          //Display error on screen
          default:
            return errorFunc(); //typically navigate("/errorscreen");
        }
      }
      break;
  }
}
